import { render } from "./restyle_menu_horisontal.vue?vue&type=template&id=2478dd62&scoped=true"
import script from "./restyle_menu_horisontal.vue?vue&type=script&lang=js"
export * from "./restyle_menu_horisontal.vue?vue&type=script&lang=js"

import "./restyle_menu_horisontal.vue?vue&type=style&index=0&id=2478dd62&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2478dd62"]])

export default __exports__